'use strict';

export default class ShowController {

  /*@ngInject*/
  constructor($http, $state, $stateParams) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
  }

  $onInit() {
    this.getData(this.$stateParams.id);
  }

  getData(id) {
    this.$http.get(`/api/myscripts/${id}`).then(res => {
      this.data = res.data;
    });
  }

}



// WEBPACK FOOTER //
// ./client/app/myscripts/show/show.controller.js